module.exports = __webpack_public_path__ + "60ad552a3a335e19dc13a0908ca09e76.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-08-harrison-allepey/IMG_0456.jpg
// module id = 607
// module chunks = 0